import CollectionSection from "components/collectionSection";

function Collection(){
    return(
        <div>
            <CollectionSection />
        </div>
    )
}
export default Collection;